module.exports = __webpack_public_path__ + "media/Yarn4.ac22bfaf.mp4";